let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5dqQO")).then(() => parcelRequire('6sj97'));